<template>
  <div>
    <strong v-text="label"></strong>
    <div class="material-switch inline mg-left-10">
      <input
        type="checkbox"
        :id="id"
        class="fu"
        :value="value"
        @change="$emit('input', ! value)"
        v-model="state"
      >
      <label :for="id" class="label-success"></label>
    </div>
  </div>
</template>

<script>
  import inputMixin from './input';

  export default {
    name: 'BlastSwitch',

    mixins: [
      inputMixin,
    ],

    data() {
      return {
        state: null,
      };
    },
    watch: {
      value() {
        this.state = this.value;
      }
    },

    mounted() {
      this.state = this.value;
    },
  };
</script>
